import { render, staticRenderFns } from "./Title2.vue?vue&type=template&id=ff234fec"
import script from "./Title2.vue?vue&type=script&lang=js"
export * from "./Title2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports